<template>
  <div v-if="list.length">
    <div class="partner-list">
      <div class="title">{{ title }}</div>
      <div
        class="partner-item"
        v-for="(item, index) in list"
        :key="index"
        @click="listevent(item)"
      >
        <div class="content">
          <div class="img">
            <img :src="item.C_LOGO" v-lazy="item.C_LOGO" />
          </div>
        </div>
      </div>
    </div>
    <div style="clear: both"></div>
  </div>
</template>
<script>
export default {
  name: "partnerList",
  components: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default: [],
    },
  },
  methods: {
    listevent(item) {
      this.$emit("listevent", item,this.title);
    },
  },
};
</script>
<style lang="scss" scoped>
.partner-list {
  padding: 5px;
  box-sizing: border-box;
  .title {
    font-size: 15px;
    font-weight: 700;
    padding-left: 5px;
  }
  .partner-item {
    width: calc(100% / 4);
    float: left;
    box-sizing: border-box;
    padding: 5px;
    .content {
      .img {
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>